/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Watermark_Preview_TitleInputs */



/**
* | output |
* | --- |
* | "Watermark on player" |
*
* @param {Options_Watermark_Preview_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_watermark_preview_title = /** @type {((inputs?: Options_Watermark_Preview_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Watermark_Preview_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Filigrane sur le lecteur")
	if (locale === "de") return /** @type {LocalizedString} */ ("Wasserzeichen im Player")
	if (locale === "it") return /** @type {LocalizedString} */ ("Filigrana sul lettore")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Водяной знак в плеере")
	if (locale === "es") return /** @type {LocalizedString} */ ("Marca de agua en el reproductor")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("播放器水印")
	if (locale === "ja") return /** @type {LocalizedString} */ ("プレーヤー上のウォーターマーク")
	if (locale === "hi") return /** @type {LocalizedString} */ ("प्लेयर पर वॉटरमार्क")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Marca de água no leitor")
	return /** @type {LocalizedString} */ ("Watermark on player")
});